<template>
	<div class="mt-6 flex flex-col gap-4 font-sans">
		<div
			class="text-secondary-900 text-center text-base leading-normal font-bold"
		>
			{{ t('newSession.addPlan') }}
		</div>
		<p class="text-center text-sm text-slate-500">
			{{ t('newSession.addPlanModalSubtitle') }}
		</p>
		<div>
			<OptionItem
				v-for="contact in contacts"
				:state="contactSelectionState(contact)"
				@click="selectedContact = contact"
			>
				{{ `${contact.firstName} ${contact.lastName}` }}
			</OptionItem>

			<OptionItem
				:state="contactSelectionState('new')"
				@click="selectedContact = 'new'"
			>
				{{ t('newSession.someoneNotListed') }}
			</OptionItem>
		</div>

		<button
			type="submit"
			class="rounded-lg border-0 px-16 py-3 text-base font-bold"
			:class="[
				canSubmit
					? 'bg-accent-400 text-accent-700 hover:bg-accent-700 hover:text-white'
					: 'text-secondary-400 bg-slate-200',
			]"
			@click.prevent="canSubmit && emit('contactSelected', selectedContact)"
		>
			{{ t('general.select') }}
		</button>
		<button
			class="text-red-500 underline"
			@click.prevent="emit('cancel')"
		>
			{{ t('general.cancel') }}
		</button>
	</div>
</template>

<script setup lang="ts">
import { SelectOptionState } from '@/enums/SelectOptionState'
import type { Contact } from '@/services/CloudSync/cloudSyncPlanService'
import OptionItem from '@/views/NewSession/PlanVersions/OptionItem.vue'
import { computed, type PropType, ref } from 'vue'
import { useI18n } from 'vue-i18n'

defineProps({
	contacts: Array as PropType<Contact[]>,
})

const emit = defineEmits(['contactSelected', 'cancel'])

const { t } = useI18n()

const selectedContact = ref<Contact | undefined | 'new'>(undefined)

const canSubmit = computed(() => {
	return selectedContact.value
})

const contactSelectionState = (contact: Contact | 'new') => {
	if (!selectedContact.value) {
		return SelectOptionState.NoSelection
	}
	if (contact === 'new') {
		return selectedContact.value === 'new'
			? SelectOptionState.Selected
			: SelectOptionState.NotSelected
	}
	const selected = selectedContact.value as Contact
	const isSelected =
		`${selected.firstName} ${selected.lastName}` ===
		`${contact?.firstName} ${contact?.lastName}`

	return isSelected ? SelectOptionState.Selected : SelectOptionState.NotSelected
}
</script>
